import headerImg from "../../assets/about/main.webp";
import { Container } from "../../components/common/Container";

import DemoImgTwo from "../../assets/about/imgOne.webp";
import DemoImgThree from "../../assets/about/imgTwo.webp";
import WorkSection from "../../components/common/work";
import Gallery from "../../components/gallery";
import { Helmet } from "react-helmet-async";

function AboutDetails() {
  return (
    <>
      <Helmet>
        <title>
          About Us | Hub Be-Connect - Empowering Digital Skills in Chitral
        </title>
        <meta
          name="description"
          content="Learn about Hub Be-Connect, Chitral's leading tech startup dedicated to equipping individuals with freelancing skills through quality training in bookkeeping, graphic design, and more."
        />
      </Helmet>
      <div>
        <div
          style={{
            backgroundImage: `linear-gradient(20deg, #082635, rgba(0,0,0,0.1)), url(${headerImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
          className="pb-24 pt-40 md:pb-52 md:pt-52"
        >
          <Container>
            <h1 className="mt-4 text-xl font-bold text-white sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">
              About Our Company
            </h1>
          </Container>
        </div>
        <div className="pt-[50px] md:pt-[80px] lg:pt-[120px]">
          <Container>
            <div className="head mb-10 md:mb-10">
              <div>
                <h2 className="mb-5 text-[24px] font-bold leading-snug text-custom-dark-blue sm:text-[36px] lg:text-[40px] xl:text-[44px] 2xl:text-[48px]">
                  We are digital creative agency in Chitral
                </h2>
                <p className="mb-4 text-xs text-gray-600 sm:text-sm md:text-base">
                  Hub Be-Connect is a start-up tech company in the Chitral
                  District. since the company stands on the notion of digital
                  skills as an academic initiative, we are offering short
                  courses & diploma courses.
                </p>
                <p className="mb-4 text-xs text-gray-600 sm:text-sm md:text-base">
                  Hub Beconnect is dedicated to equipping individuals and
                  organizations with the vital freelancing skills necessary to
                  thrive in the modern digital landscape. Founded on the
                  principles of innovation, excellence, and community, we
                  provide top-tier training in essential areas such as
                  bookkeeping and graphic designing.
                </p>
                <p className="mb-4 text-xs text-gray-600 sm:text-sm md:text-base">
                  At Hub Beconnect, we are committed to exceptional service and
                  integrity.
                </p>
                <p className="mb-4 text-xs text-gray-600 sm:text-sm md:text-base">
                  Our team of experienced professionals understands the unique
                  needs of our clients, offering tailored solutions that help
                  them navigate complexity, seize opportunities, and excel in
                  their careers. By fostering a supportive community of skilled
                  professionals, we enable collaboration, knowledge sharing, and
                  mutual growth.
                </p>
                <p className="mb-4 text-xs text-gray-600 sm:text-sm md:text-base">
                  Join us at Hub Beconnect and take the next step in your
                  professional journey. Together, we can achieve excellence and
                  strategic success
                </p>
              </div>
            </div>
            <div className="flex h-full flex-wrap justify-between">
              <div className="mb-6 h-[300px] w-full sm:mb-0 sm:h-[400px] sm:w-[67%]">
                <img
                  src={DemoImgTwo}
                  alt="about img"
                  className="h-full w-full rounded-2xl object-cover shadow-lg"
                />
              </div>
              <div className="hidden w-full sm:block sm:h-[400px] sm:w-[30%]">
                <img
                  src={DemoImgThree}
                  alt="about img"
                  className="h-full w-full rounded-2xl object-cover shadow-lg"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 flex-wrap justify-between gap-4 py-10 sm:grid-cols-2 sm:gap-10 md:grid-cols-3">
              <div className="mb-6 w-full sm:mb-0">
                <span className="mb-2 flex h-[25px] w-[25px] items-center justify-center rounded-md border border-dashed border-custom-orange text-sm font-bold text-custom-orange">
                  01
                </span>
                <h3 className="mb-2 text-lg font-semibold text-custom-dark-blue sm:text-xl md:text-2xl">
                  Our{" "}
                  <span className="fontSuse text-custom-orange">Vision</span>
                </h3>
                <p className="text-light text-xs text-gray-600 sm:text-sm">
                  To be the leading partner in empowering individuals and
                  businesses through innovative skill development, driving
                  sustainable growth and lasting impact.
                </p>
              </div>
              <div className="mb-6 w-full sm:mb-0">
                <span className="mb-2 flex h-[25px] w-[25px] items-center justify-center rounded-md border border-dashed border-custom-orange text-sm font-bold text-custom-orange">
                  02
                </span>
                <h3 className="mb-2 text-lg font-semibold text-custom-dark-blue sm:text-xl md:text-2xl">
                  Our{" "}
                  <span className="fontSuse text-custom-orange">Mission</span>
                </h3>
                <p className="text-light text-xs text-gray-600 sm:text-sm">
                  We aim to bridge the skills gap by providing accessible,
                  top-quality training, fostering a community of skilled
                  professionals ready to excel in today’s digital landscape.
                </p>
              </div>
              <div className="mb-6 w-full sm:mb-0">
                <span className="mb-2 flex h-[25px] w-[25px] items-center justify-center rounded-md border border-dashed border-custom-orange text-sm font-bold text-custom-orange">
                  03
                </span>
                <h3 className="mb-2 text-lg font-semibold text-custom-dark-blue sm:text-xl md:text-2xl">
                  Our <span className="fontSuse text-custom-orange">Goals</span>
                </h3>

                <p className="text-light text-xs text-gray-600 sm:text-sm">
                  We aim to empower individuals with freelancing skills, provide
                  market-driven training, ensure quality, drive growth, and
                  build a supportive professional community.
                </p>
              </div>
            </div>
            <WorkSection />
          </Container>
          <Gallery />
        </div>
      </div>
    </>
  );
}

export default AboutDetails;
